<template>
    <div>
        <div v-if="programWithHistory != null && !loading" class="profile__container--content__membershipProgram--info-page text-center" :class="$vuetify.breakpoint.smAndDown ? 'py-5' : ''">
            <div class="profile__container--content__membershipProgram--info-page__title">
                Du har <br>
                <span class="profile__container--content__membershipProgram--info-page__title--points">{{program.pointsEarned}}</span> <br>
                poeng
            </div>
            <div class="d-flex justify-center my-14">
                <animated-icon size="174" icon="fxt-vip-fist" iconColor="primary" backgroundColor="var(--v-primary-opacity-12)"></animated-icon>
            </div>
            <div class="profile__container--content__membershipProgram--info-page__description mb-5">
                <p><span v-html="program.joinDescription"></span></p>
            </div>
            <div class="d-flex flex-column justify-center align-center">
                <v-btn
                    class="font-weight-bold secondary-font text-none my-2"
                    color="primary"
                    rounded
                    elevation="0"
                    :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width:50%'"
                    :disabled="program.pointsEarned == 0"
                    @click="switchComponent('Poenghistorikk')"
                >
                    Vis poenghistorikk
                </v-btn>
                <v-btn
                    class="font-weight-bold secondary-font text-none my-2"
                    color="primary"
                    rounded
                    outlined
                    :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width:50%'"
                    @click="switchComponent('Vilkår for bruk')"
                >
                    Vilkår for bruk
                </v-btn>
                <v-btn
                    class="font-weight-bold secondary-font text-none my-2"
                    color="primary"
                    text
                    elevation="0"
                    rounded
                    :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width:50%'"
                    @click="showDialog = true"
                >
                    Meld meg ut
                </v-btn>
            </div>
            <common-dialog 
                v-if="showDialog" 
                :show="showDialog" 
                :title="`Vil du melde deg ut av ${program.programName}?`" 
                icon="fxt-warning" 
                buttonTextConfirm="Meld meg ut" 
                @closeDialog="showDialog = false"
                @confirmAction="leaveProgram()"
                :layout="layout"
            >
                <p>Du vil ikke opptjene poeng lengre, men du mister ikke poengene du allerede har opptjent. Hvis du melder deg inn igjen vil du få tilbake poengene du har, så lenge poengene ikke er utgått.</p>
            </common-dialog>
        </div>
        <div v-else>
            <v-overlay :value="loading" color="white" absolute style="height: 600px">
                <v-progress-circular
                    color="var(--v-primary-base)"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>

<script>
import { CommonDialog } from '../../../../Common/CommonComponents'
import AnimatedIcon from '../../../../Common/CommonComponents/AnimatedIcon.vue'
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: { AnimatedIcon, CommonDialog },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        programId: {
            required: false,
            default: 0,
            type: Number
        },
        siteId: {
            required: false,
            default: 0,
            type: Number
        }
    },
    data: () => ({
        showDialog: false,
        programWithHistory: null,
        loading: false,
    }),
    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        program() {
            return this.programWithHistory.program
        }
    },
    methods: {
        switchComponent(route) {
            if (this.layout == 'chain') {
                this.$router.replace({query: { title: this.toUrlSafe(route), id: this.program.customerProgramId, siteId: this.$route.query.siteId}, params: {program: this.program}})
            } else {
                this.$router.push({name: route, params: {id: this.program.customerProgramId, program: this.program}, query: {siteId: this.program.customer.siteId}})
            }
        },
        toUrlSafe(string) {
            return string.toLowerCase().replaceAll(' ', '-').replaceAll('å', 'aa')
        },
        getCustomerCategoryId() {
            return this.program.customerCategories.length 
            ? this.program.customerCategories.find(x => x.customerProgramId == this.program.customerProgramId).customerCategoryId 
            : this.program.customerCategories[0].customerCategoryId 
            || null
        },
        infoText() {
            var productsDiscount = this.programWithHistory.program.productDiscountPercentage
            var treatmentDiscount = this.programWithHistory.program.treatmentDiscountPercent
            switch (true) {
                case productsDiscount != 0 && treatmentDiscount != 0:
                    return `${this.programWithHistory.program.programName} gir deg ${productsDiscount}% bonus ved kjøp av produkter, og ${treatmentDiscount}% bonus ved kjøp av behandlinger.`
                case productsDiscount == 0 && treatmentDiscount != 0:
                    return `${this.programWithHistory.program.programName} gir deg ${treatmentDiscount}% bonus ved kjøp av behandlinger.`
                case productsDiscount != 0 && treatmentDiscount == 0:
                    return `${this.programWithHistory.program.programName} gir deg ${productsDiscount}% bonus ved kjøp av produkter.`
                case productsDiscount == 0 && treatmentDiscount == 0:
                    return ``
            }
        },
        async leaveProgram() {
            this.loading = true;
            var result = await profileSvc.AddOrRemoveCustomerProgram(this.bookingApi, {
                registerCustomerInCustomerProgram: false,
                customerCategoryId: this.getCustomerCategoryId() != null ? this.getCustomerCategoryId() : this.program.defaultCustomerCategoryId,
                chainId: this.program.chainId,
                siteId: 0, //This field isn't being used backend, so it's set to a static 0.
            })
            if (result) {
                if (this.layout == 'portal') {
                    this.$router.replace({name: 'Bli med i fordelsprogram', params: {id: this.program.customerProgramId, program: this.program}, query: {siteId: this.program.customer.siteId}}) 
                } else {
                    this.$emit('refresh')
                }
            }
            this.showDialog = false
            this.loading = false
        }
    },
    async created() {
        this.loading = true
        profileSvc = await ProfileSvc(this.$axios);
        this.programWithHistory = await profileSvc.GetCustomerProgramById(this.bookingApi, this.layout == 'portal' ? this.$route.params.id : this.programId, this.$route.query.siteId ? this.$route.query.siteId : this.siteId)
        this.loading = false
	},
    beforeDestroy() {
		profileSvc = null
	}
}
</script>